import { registerHandler } from '@/utils/queues/pc-queues'

export const registerHandlerElementDetailsModalScript = (): void => {
  registerHandler('element.detailsModalScript', function (...args) {
    // Don't generate an extra chunk so that no additional network requests are made, because
    // promo banners appear on almost all pages using this entry point and are typically at the top of the page.
    import(
      /* webpackMode: 'eager', webpackChunkName: '@/elements/details-modal-script' */ '@/elements/details-modal-script'
    ).then(({ init }) => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore: Inlined JavaScript is inherently not type checked
      init(...args)
    })
  })
}
